// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"e14cf1ba","703":"d4bfc6ac"}[chunkId] + ".chunk.js";
};